function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 54,
  height: 50,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 27.439,
  cy: 22.911,
  r: 20.911,
  stroke: "#fff",
  strokeWidth: 2.652,
  style: {
    mixBlendMode: "screen"
  }
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2.922,
  d: "m2 48 25.257-25.257L52.514 48",
  style: {
    mixBlendMode: "screen"
  }
}));
export { SvgLogoWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTQiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1NCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxjaXJjbGUgY3g9IjI3LjQzOTMiIGN5PSIyMi45MTE0IiByPSIyMC45MTE0IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIuNjUyMjkiIHN0eWxlPSJtaXgtYmxlbmQtbW9kZTpzY3JlZW4iLz4NCjxwYXRoIGQ9Ik0yIDQ4TDI3LjI1NzEgMjIuNzQyOUw1Mi41MTQyIDQ4IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIuOTIxNjkiIHN0eWxlPSJtaXgtYmxlbmQtbW9kZTpzY3JlZW4iLz4NCjwvc3ZnPg0K";